<template>
  <b-card title="Топ ведущих по числу игр" class="h-100">
    <vue-good-table :rows="hosts" :columns="columns" :pagination-options="{ enabled: false }" :sort-options="{ enabled: false }">
      <template slot="emptystate">
        <div class="text-center text-muted py-2">Нет данных</div>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'name'">
          {{ props.row.name || props.row.tg_username || `host_id: ${props.row.host_id}` }}
        </span>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: { BCard, VueGoodTable },
  props: {
    hosts: { type: Array, default: () => [] },
  },
  data() {
    return {
      columns: [
        { label: 'Ведущий', field: 'name' },
        { label: 'Игр', field: 'games_count', type: 'number' },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
